"use client";

import { AppendReturnUrl } from "@/services/AppendReturnUrl";
import { useSearchParams } from "next/navigation";

interface AuthError {
  title: string;
  body: string;
}

const AUTH_ERROR_MESSAGES: {
  [key: string]: AuthError;
} = {
  Verification: {
    title: "Login failed, please try again",
    body: "The link you used is invalid or has expired.  Did you request multiple sign in links? If so, please use the most recent email we sent you.",
  },
  AccessDenied: {
    title: "Access denied",
    body: "You do not have permission to access this account.",
  },
  Configuration: {
    title: "Sorry, something went wrong",
    body: "We'll be taking a look, please contact us if the problem persists.",
  },
};

const AUTH_ERROR_DEFAULT: AuthError = {
  title: "Please try again or contact us for support",
  body: "An unknown error occurred.",
};

export function useAuthSearchParams() {
  const searchParams = useSearchParams();
  let returnUrl = searchParams.get("returnUrl");
  if (!returnUrl || returnUrl.startsWith("/auth")) {
    returnUrl = "/";
  }
  const emailOrUsernameParam = searchParams.get("emailOrUsername") ?? "";
  const error = searchParams.get("error");
  return {
    returnUrl,
    emailOrUsernameParam,
    appendAuthSearchParams: (url: string, newEmailOrUsername?: string) =>
      AppendReturnUrl(url, returnUrl) +
      ((newEmailOrUsername ?? emailOrUsernameParam)
        ? `&emailOrUsername=${encodeURIComponent(newEmailOrUsername ?? emailOrUsernameParam)}`
        : ""),
    error: error
      ? (AUTH_ERROR_MESSAGES[error] ?? AUTH_ERROR_DEFAULT)
      : undefined,
  };
}
